import useBodyScrollLock from "hooks/useBodyScrollLock";
import React, { MouseEvent, ReactNode, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

interface ModalLayoutProps {
  children: ReactNode;
  handleModalClose: () => void;
  isNoBg?: boolean;
  isOutsideClick?: boolean;
}

const ModalLayout = ({
  children,
  handleModalClose,
  isNoBg = false,
  isOutsideClick = true,
}: ModalLayoutProps) => {
  const portalRoot = document.getElementById("modal") as HTMLElement;

  const { lockScroll, openScroll } = useBodyScrollLock();

  const modalOutsideRef = useRef<HTMLDivElement>(null);

  // 모달 바깥 부분 클릭 시 모달 닫히는 기능
  const modalOutsideClick = (e: MouseEvent) => {
    if (!isOutsideClick) return;
    if (modalOutsideRef.current === e.target) {
      handleModalClose();
    }
  };

  // esc 키 누르면 모달 닫히는 기능
  useEffect(() => {
    if (!isOutsideClick) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleModalClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    lockScroll();

    return () => {
      openScroll();
      document.removeEventListener("keydown", handleEscape);
    };
  }, [handleModalClose]);

  return ReactDOM.createPortal(
    <ModalLayoutContainer
      ref={modalOutsideRef}
      onClick={modalOutsideClick}
      $isNoBg={isNoBg}
    >
      {children}
    </ModalLayoutContainer>,
    portalRoot
  );
};

export default ModalLayout;

const ModalLayoutContainer = styled.div<{ $isNoBg: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${({ $isNoBg }) =>
    $isNoBg ? "transparent" : "rgba(0, 0, 0, 0.4)"};
  z-index: 100;
`;
